import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, mergeProps as _mergeProps, vShow as _vShow, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "login-wrapper"
};
const _hoisted_2 = { class: "animate login-form clearfix" };
const _hoisted_3 = { class: "form-container clearfix" };
const _hoisted_4 = { class: "form-header dark clearfix" };
const _hoisted_5 = { class: "float-start" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fa-stack fa-lg fa-2x white-text" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-circle fa-stack-2x" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-unlock-alt fa-stack-1x fa-inverse dark-blue-text" })
], -1 /* HOISTED */);
const _hoisted_7 = { class: "content-title" };
const _hoisted_8 = { class: "hidden-sm" };
const _hoisted_9 = { class: "visible-sm" };
const _hoisted_10 = { class: "form-body clearfix bg-white" };
const _hoisted_11 = {
    key: 0,
    class: "col-xs-12 text-center py-4"
};
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-spinner fa-spin fa-2x" }, null, -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-muted" }, "Checking authentication options...", -1 /* HOISTED */);
const _hoisted_14 = {
    key: 1,
    class: "col-xs-12 col-sm-12 top20 w-100"
};
const _hoisted_15 = { class: "mb-4" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", { class: "form-label" }, "Select Your Organization", -1 /* HOISTED */);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("option", { value: null }, "-- Select Company --", -1 /* HOISTED */);
const _hoisted_18 = ["value"];
const _hoisted_19 = {
    key: 2,
    class: "col-xs-12 col-sm-12 top20 w-100"
};
const _hoisted_20 = { class: "text-center mb-4" };
const _hoisted_21 = { class: "mb-3" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-sign-in me-2" }, null, -1 /* HOISTED */);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("div", { class: "text-center my-3" }, [
    /*#__PURE__*/ _createElementVNode("hr", { class: "my-3" }),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "Or use breakglass account")
], -1 /* HOISTED */);
const _hoisted_24 = {
    key: 3,
    class: "col-xs-12 col-sm-12 top10 w-100"
};
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "\r\n\t\t\t\t\t\t\t\tUsername\r\n\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_26 = { class: "invalid-feedback" };
const _hoisted_27 = {
    key: 4,
    class: "col-xs-12 col-sm-12 top20 w-100"
};
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "\r\n\t\t\t\t\t\t\t\tPassword\r\n\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_29 = { class: "invalid-feedback" };
const _hoisted_30 = { class: "float-end top10" };
const _hoisted_31 = {
    key: 5,
    class: "col-xs-12 top10 float-end"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("form", null, [
        (!_ctx.loginState.isLoggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _hoisted_6,
                                _createTextVNode(),
                                _createElementVNode("h1", _hoisted_7, [
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.loginTitle(false)), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.loginTitle(true)), 1 /* TEXT */)
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_10, [
                            _createCommentVNode(" Show loading state while checking SSO "),
                            _createTextVNode(),
                            (_ctx.isCheckingSso)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _hoisted_12,
                                    _createTextVNode(),
                                    _hoisted_13
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            _createCommentVNode(" Company Selection for SSO (only in dev/staging when no subdomain) "),
                            _createTextVNode(),
                            (!_ctx.isCheckingSso && _ctx.showCompanySelection && _ctx.isDevelopmentOrStaging)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _hoisted_16,
                                        _createTextVNode(),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                                            class: "form-select"
                                        }, [
                                            _hoisted_17,
                                            _createTextVNode(),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ssoCompanies, (company) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: company.companyId,
                                                    value: company.companyId
                                                }, _toDisplayString(company.companyName), 9 /* TEXT, PROPS */, _hoisted_18));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 512 /* NEED_PATCH */), [
                                            [_vModelSelect, _ctx.selectedCompanyId]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            _createCommentVNode(" SSO Login Button "),
                            _createTextVNode(),
                            (!_ctx.isCheckingSso && _ctx.isSsoAvailable)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.ssoMessage), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "primary",
                                            onClick: _ctx.ssoLogin,
                                            class: "btn-lg",
                                            disabled: _ctx.showCompanySelection && !_ctx.selectedCompanyId
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_22,
                                                _createTextVNode("Login with SSO\r\n\t\t\t\t\t\t\t\t")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick", "disabled"])
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_23
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            _createCommentVNode(" Standard Login Fields "),
                            _createTextVNode(),
                            (!_ctx.isCheckingSso)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _hoisted_25,
                                    _createTextVNode(),
                                    _createVNode(_component_b_form_input, _mergeProps(_ctx.usernameVal, {
                                        type: "text",
                                        modelValue: _ctx.userName,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.userName) = $event)),
                                        modelModifiers: { trim: true },
                                        name: "username",
                                        class: { 'is-invalid': _ctx.errors && _ctx.errors.username },
                                        onKeyup: _withKeys(_ctx.attemptLogin, ["enter"]),
                                        autocomplete: "username",
                                        required: ""
                                    }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "onKeyup"]),
                                    _createTextVNode(),
                                    _withDirectives(_createElementVNode("div", _hoisted_26, "\r\n\t\t\t\t\t\t\t\t* Please enter your login\r\n\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                        [_vShow, _ctx.errors && _ctx.errors.username]
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            (!_ctx.isCheckingSso)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _hoisted_28,
                                    _createTextVNode(),
                                    _createVNode(_component_b_form_input, _mergeProps(_ctx.passwordVal, {
                                        type: _ctx.passwordInputType,
                                        modelValue: _ctx.password,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.password) = $event)),
                                        modelModifiers: { trim: true },
                                        name: "password",
                                        class: { 'is-invalid': _ctx.errors && _ctx.errors.password },
                                        onKeyup: _withKeys(_ctx.attemptLogin, ["enter"]),
                                        autocomplete: "current-password",
                                        required: ""
                                    }), null, 16 /* FULL_PROPS */, ["type", "modelValue", "class", "onKeyup"]),
                                    _createTextVNode(),
                                    _withDirectives(_createVNode(_component_b_button, {
                                        type: "button",
                                        class: "password-visibility-toggle",
                                        onClick: _ctx.togglePasswordVisibility
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("i", {
                                                class: _normalizeClass(_ctx.passwordIconClass)
                                            }, null, 2 /* CLASS */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick"]), [
                                        [_vShow, _ctx.errors && !_ctx.errors.password]
                                    ]),
                                    _createTextVNode(),
                                    _withDirectives(_createElementVNode("div", _hoisted_29, "\r\n\t\t\t\t\t\t\t\t* Please enter your password\r\n\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                        [_vShow, _ctx.errors && _ctx.errors.password]
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_30, [
                                        _withDirectives(_createVNode(_component_router_link, {
                                            to: { name: 'forgotten-password' },
                                            class: "blue"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tForgot your password?\r\n\t\t\t\t\t\t\t\t")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 512 /* NEED_PATCH */), [
                                            [_vShow, !_ctx.isThirdPartyAuth]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            (!_ctx.isCheckingSso)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "primary",
                                        onClick: _ctx.attemptLogin
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.statusText), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick"])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true)
    ]));
}
